var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"root"}},[_c('div',{attrs:{"id":"info"}},[_c('img',{attrs:{"id":"logo","alt":"FINNOMENA","src":require("../assets/logo.png")}}),_c('p',[_vm._v(_vm._s(_vm.version))])])])}
var staticRenderFns = []

export { render, staticRenderFns }